import { createIcon } from '@chakra-ui/icons';

const SwapIcon = createIcon({
  displayName: 'SwapIcon',
  viewBox: '0 0 14 8',
  path: (
    <path
      d="M11.6667 0.666667C11.6667 0.489856 11.5965 0.320287 11.4714 0.195262C11.3464 0.070238 11.1769 0 11 0H5.66671V1.33333H10.3334V4.66667H8.33337L10.9794 8L13.6667 4.66667H11.6667V0.666667ZM2.33337 7.33333C2.33337 7.51014 2.40361 7.67971 2.52864 7.80474C2.65366 7.92976 2.82323 8 3.00004 8H8.33337V6.66667H3.66671V3.33333H5.66671L3.00004 0L0.333374 3.33333H2.33337V7.33333Z"
      fill="#A0AEC0"
    />
  ),
});

export default SwapIcon;
